import React from "react";

export enum ObsTabs {
  VITALS_SIGNS = "vitalsSigns",
  NEUROLOGICAL = "neurovascular",
  BEDSIDE = "bedside",
  VENTILATOR = "ventilator",
  URINALYSIS = "urinalysis",
}

export const tabNames = {
  [ObsTabs.VITALS_SIGNS]: "Vitals signs",
  [ObsTabs.NEUROLOGICAL]: "Neurological & Neurovascular",
  [ObsTabs.BEDSIDE]: "Post/Bilat BP",
  [ObsTabs.VENTILATOR]: "Ventilator",
  [ObsTabs.URINALYSIS]: "Urinalysis & Pregnancy",
} as const;


export type ObsTabsCtxValue = {
  value: {
    tab: ObsTabs;
  },
  set: (v: ObsTabsCtxValue[ "value" ]) => unknown,
  setTab: (tab: ObsTabs) => void,
  getTabName: (tab: ObsTabs) => typeof tabNames[ObsTabs]
}
export const defaultObsTabsCtxValue: ObsTabsCtxValue = {
  value: { tab: ObsTabs.VITALS_SIGNS },
  set: console.log,
  setTab: console.log,
  getTabName: (tab:ObsTabs) => tabNames[ObsTabs.VITALS_SIGNS]
};

export const ObsTabsCtx = React.createContext(defaultObsTabsCtxValue);
export const useObsTabsCtx = () => React.useContext(ObsTabsCtx);

export const WithObsTabsCtx: React.FC< React.PropsWithChildren > = React.memo(p => {
  const [value, set] = React.useState(defaultObsTabsCtxValue.value);
  const getTabName = React.useCallback((tab:ObsTabs) => tabNames[tab], [tabNames]);

  const setTab = React.useCallback((tab: ObsTabs) => {
    set({tab});
  },[set, value.tab]);

  const ctxValue = React.useMemo(() => ({value, set, setTab, getTabName}), [value, set, setTab, getTabName]);

  return (
    <ObsTabsCtx.Provider value={ ctxValue }>
      { p.children }
    </ObsTabsCtx.Provider>
  );
});
WithObsTabsCtx.displayName = "components/ObservationChart/WithObsTabsCtx";
